<template>
<div class="chapter">
<div class="inner_page">
<div class="img_containert"><img alt="images" src="images/fifc-01.jpg"/></div>
<p class="caption">The stunning shape of the rare, Malcolm Sayer-designed Low Drag E-Type seen from above with the aero design features obvious.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm01.vue?b2edfdf0